import React, { CSSProperties, ReactNode } from 'react';
import { Typography } from 'antd';
import { legacyTextColor } from '@/utils/legacyColor';

const { Title } = Typography;

interface CustomTitleProps {
  style?: CSSProperties;
  required?: boolean;
  text?: ReactNode;
  level?: 1 | 2 | 3 | 4 | 5;
  color?: string;
  whiteSpace?:
    'normal' | 'nowrap' | 'pre' | 'pre-wrap' | 'pre-line' | 'break-spaces';
  fontSize?: string | number;
  lineHeight?: string | number;
  marginTop?: string | number;
  marginBottom?: string | number;
  fontWeight?: string | number;
  textAlign?: 'left' | 'center' | 'right' | 'justify';
  className?: string;
}

const CustomTitle: React.FC<CustomTitleProps> = ({
  style,
  required,
  text,
  level,
  color,
  whiteSpace = 'normal',
  fontSize,
  lineHeight,
  marginTop,
  marginBottom,
  fontWeight,
  textAlign,
  className,
}) => {
  return (
    <Title
      className={className}
      level={level}
      style={{
        ...style,
        color: legacyTextColor(color),
        fontSize: fontSize,
        whiteSpace: whiteSpace,
        lineHeight: lineHeight,
        marginTop: marginTop,
        marginBottom: marginBottom,
        fontWeight: fontWeight,
        textAlign: textAlign,
      }}
    >
      {text}
      {required && (
        <span style={{ color: 'var(--danger)', fontSize: '14px' }}> *</span>
      )}
    </Title>
  );
};

export default CustomTitle;
